"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnSaleFilterOption = void 0;
const mobx_1 = require("mobx");
class OnSaleFilterOption {
    constructor() {
        this.onSale = false;
        this.setOnSale = (onSale) => {
            this.onSale = onSale;
        };
        this.reset = () => {
            this.onSale = false;
        };
    }
    get isSet() {
        return this.onSale;
    }
}
exports.OnSaleFilterOption = OnSaleFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], OnSaleFilterOption.prototype, "onSale", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], OnSaleFilterOption.prototype, "setOnSale", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], OnSaleFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], OnSaleFilterOption.prototype, "isSet", null);
//# sourceMappingURL=OnSaleFilterOption.js.map